import React from 'react';
import { connect } from 'react-redux';
import { iframeResizer as iframeResizerLib } from 'iframe-resizer';
import PropTypes from 'prop-types';
import { servicios } from '../properties';

const ubicacionN = require('../img/localizaN.svg');

const mapState = (state) => {
  return {
    loading: state.global.loading,
    paso: state.directorio.paso,
    cliente: state.global.clienteUnico,
    tid: state.global.tid,
    test11: state,
  };
};

const mapDispatch = (dispatch) => {
  return {
    pasoReset: () => {
      dispatch({ type: 'DIRECTORIO_PASO', paso: 0 });
    },
    alerta: (
      sTitulo,
      sMensaje,
      sNameBtnCancel,
      fnCancel,
      sNameBtnConfirm,
      fnConfirm,
      sCode
    ) => {
      dispatch({
        type: 'MODAL_ALERT_CONFIRM',
        titulo: sTitulo,
        mensaje: sMensaje,
        nameBtnCancel: sNameBtnCancel,
        accionCancel: fnCancel,
        nameBtnConfirm: sNameBtnConfirm,
        accionConfirm: fnConfirm,
        codigo: sCode,
      });
    },
  };
};

class TarjetasFrame extends React.Component {
  state = {
    ingresoHospitalario: false,
    valoresIngresoHospitalario: null,
    tabActivaStr: 'ingresoHospitalario',
  };

  componentWillMount = () => {
    this.props.pasoReset();
  };

  resizeIframe = () => {
    const { iFrame } = this.refs;
    if (!iFrame) return;
    this.iframeResizer = iframeResizerLib(
      {
        log: false,
        heightCalculationMethod: 'taggedElement',
        autoResize: true,
      },
      iFrame
    );
  };

  componentDidMount = () => {
    let directorio = document.getElementById('tarjetas-frame');
    directorio.setAttribute('allow', 'geolocation');
    var parentDiv = directorio.parentNode;
    parentDiv.replaceChild(
      document.getElementById('tarjetas-frame'),
      directorio
    );
  };

  onLoadIframe = () => {
    this.resizeIframe();
  };

  getSrcDirectorio() {
    let directorio = servicios.tarjetasFrame.endPoint;
    let certificado = '';
    console.log('Propiedades', this.props);
    if (Object.keys(this.props.test11.polizas).length > 0) {
      certificado = this.props.test11.polizas.poliza.asegurados[0].certificado;
    }
    if (this.props && this.props.cliente) {
      directorio =
        directorio +
        '?origen' +
        '=' +
        'cliente' +
        '&' +
        'clienteUnico' +
        '=' +
        this.props.cliente +
        '&' +
        'poliza=' +
        this.props.test11.polizas.polizaSeleccionada +
        '&' +
        'certificado=' +
        certificado +
        '&' +
        'jwt=' +
        localStorage.getItem('refreshToken');
    } else {
      directorio = directorio + '?origen' + '=' + 'corporativo';
    }

    return directorio;
  }

  render() {
    const propsComunes = {
      id: 'tarjetas-frame',
      ref: 'iFrame',
      frameBorder: '0',
      width: '100%',
      height: '820px',
      src: this.getSrcDirectorio(),
      allow: 'geolocation',
    };

    return (
      <iframe {...propsComunes} onLoad={this.onLoadIframe} props={this.props} />
    );
  }
}

TarjetasFrame.propTypes = {
  loading: PropTypes.bool,
  paso: PropTypes.number,
  cliente: PropTypes.string,
  tid: PropTypes.string,
};

export default connect(mapState, mapDispatch)(TarjetasFrame);



// WEBPACK FOOTER //
// ./src/tarjetas-frame/tarjetas-frame.cmpt.js